"use client"

import type { ReactNode } from "react"
import { useState, useEffect } from "react"
import { useAuth } from "@/components/auth-provider"
import { authClient } from "@/lib/auth"
import { get, post } from "@/lib/api"
import { getDeviceId } from "@new-cti/frontend-shared/auth/device-id"
import { useSessionGuard } from "@new-cti/frontend-shared/auth/hooks"
import { SessionLockOverlay } from "@new-cti/frontend-shared/auth/session-lock-overlay"
import { SESSION_APP } from "@new-cti/frontend-shared/auth/session-api"

// このアプリの api クライアント（get/post のみ必要）。安定参照にするためモジュールスコープに置く。
const sessionApi = { get, post }

/**
 * 複数端末同時ログインの締め出しゲート（driver）。
 *
 * ログイン確定後にこのアプリ(driver)の所有端末をこの端末に確定し、別端末が後からログインすると
 * この端末を全画面ロックしてログインへ誘導する。排他はアプリ単位なので、同一アカウントでも
 * staff ページは driver スマホのログインで締め出されない。
 */
export function SessionGuardGate({ children }: { children: ReactNode }) {
  const { isLoggedIn, logout } = useAuth()
  const [deviceId, setDeviceId] = useState("")
  useEffect(() => {
    setDeviceId(getDeviceId())
  }, [])

  const locked = useSessionGuard(authClient, sessionApi, SESSION_APP.driver, deviceId, isLoggedIn && !!deviceId)

  return (
    <>
      {children}
      {locked && <SessionLockOverlay onRelogin={() => { void logout() }} />}
    </>
  )
}
